







































import { Vue, Component } from 'vue-property-decorator';
import VoteButton from '@/components/VoteButton.vue';
import CommentList from './components/CommentList.vue';
import CommentInput from './components/CommentInput.vue';
import { getLocation } from './api/api';
import { getBaseinfo } from '@/api/api';
import { appShare, wxShareInfo } from '@/common/ts/common';
@Component({
  components: {
    VoteButton,
    CommentList,
    CommentInput,
  },
})
export default class Home extends Vue {
  testSHow: boolean = false;
  voteName: string = '2019poject/2019new70years';
  location: any[] = [];
  top: any = {};
  totalVoteNum: number = 0;
  async created() {
    const res = await getLocation(this.voteName);
    if ((res as any).code === 200) {
      this.location = res.data.locationList;
      this.top = res.data.top;
    }
    const Baseinfo = await getBaseinfo(this.voteName);
    if ((Baseinfo as any).code === 200) {
      this.totalVoteNum = (Baseinfo as any).data.totalVoteNum;
    }
    appShare({
      title: '壮丽70年，老区焕新颜',
      url: window.location.href,
      subtitle: '壮丽70年，老区焕新颜',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '壮丽70年，老区焕新颜',
      subtitle: '壮丽70年，老区焕新颜',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  mounted() {
    console.log(
      'scrollTop',
      document.getElementsByClassName('home')[0].scrollTop,
    );
  }
  enterDetailPage(e: any) {
    this.$router.push({ path: './detail', query: { locationId: e.id } });
  }
}
